import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { stackActions, getStacks, getSelectedStack } from "data/stackApi"

class WithStacks extends React.Component {
    render() {
        const stacksData = this.props.stacks
        if (!stacksData) return this.props.loading ? this.props.loading : ""
        const stacks = Object.values(stacksData)
        return this.props.children({
            stacks,
            createStack: this.props.stackActions.create,
            onChange: this.props.stackActions.update,
            selectStack: this.props.stackActions.selectStack,
            selectedStack: this.props.selectedStack,
        })
    }

    constructor(props) {
        super(props)
        props.stackActions.fetch()
    }
}

WithStacks.propTypes = {}

function mapStateToProps(state) {
    return {
        stacks: getStacks(state),
        selectedStack: getSelectedStack(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        stackActions: bindActionCreators(stackActions, dispatch),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithStacks)



// WEBPACK FOOTER //
// ./src/data/wrappers/WithStacks.js